export default {
  state: {
      menuTree: [],
  },
  getters: {
      setMenuTree(state, menuTree) {
          state.menuTree = menuTree
      }
  },
  mutations: {
      setMenuTree(state, menuTree) {
          state.menuTree = menuTree
      }
  }
}



// WEBPACK FOOTER //
// ./src/store/menuTree/index.js